'use strict';

import api from '../api';

const logIn = ({commit}, options) => {
  return api.Login.create({params: {login: options}})
    .then(userAuth => commit('logIn', userAuth));
};

const logOut = ({commit}) => commit('logOut');

const configNavigation = ({commit}, config = {}) => commit('configNavigation', config);

const destroyStripeCard = ({commit}, options) => api.StripeCard.destroy(options);

const updateCachedPool = ({commit}, options) => api.Pool.show(options).then(pool => commit('updateCachedPool', pool));
const destroyCachedPool = ({commit}, options) => api.Pool.destroy(options).then(() => commit('destroyCachedPool', options.params.pool.id));

const updateDashboardPools = ({commit}) => {
  return api.DashboardPool.index()
    .then(pools => {
      commit('updateDashboardPools', pools);
      pools.forEach(pool => commit('updateCachedPool', pool));
    });
};

//const updateParticipationsAwaitingUser = ({commit, dispatch}) => {
//  return api.ParticipationAwaitingUser.index()
//    .then(participations => {
//      commit('updateParticipationsAwaitingUser', participations);
//      return participations;
//    }).then(participations => {
//      return axios.all(
//        participations.map(participation => dispatch('updateCachedPool', {params: {id: participation.pool.id}}))
//      );
//    });
//};

export default {
  logIn,
  logOut,
  configNavigation,
  destroyStripeCard,
  updateCachedPool,
  destroyCachedPool,
  updateDashboardPools,
//  updateParticipationsAwaitingUser
};
